import { TypeKoodoErrorPageButtonFields } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

// Component
import KoodoErrorPageButton from './KoodoErrorPageButton'

const ContentfulKoodoErrorPageButton = withContentful<TypeKoodoErrorPageButtonFields>(KoodoErrorPageButton, {
  text: (props) => props.fields?.text,
  url: (props) => props.fields?.url,
  intcmpRef: (props) => props.fields?.intcmpRef,
  target: (props) => props.fields?.target,
  analyticsEvent: (props) => props.fields?.analyticsEvent,
})

export default ContentfulKoodoErrorPageButton
